import { render } from "./NotFoundPage.vue?vue&type=template&id=b302c99c&scoped=true"
const script = {}

import "./NotFoundPage.vue?vue&type=style&index=0&id=b302c99c&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b302c99c"]])

export default __exports__